import axios from 'axios';
import api from '../api/api';

// TODO: Replace with actual types
export type Quiz = {
  id: number;
  title: string;
  description?: string;
  school_id: number;
  course_id: number;
  class_level?: string;
  created_by: number;
  mode: string;
  start_time?: string;
  end_time?: string;
  duration_minutes?: number;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
  questions?: any[];
};
export type QuizAttempt = any;
export type QuizResponse = any;
export type QuizResults = any;

export async function createQuiz(quizData: Quiz) {
  const res = await api.post('/api/quizzes', quizData);
  return res.data as Quiz;
}

export async function listQuizzes(): Promise<Quiz[]> {
  const res = await api.get('/api/quizzes');
  return res.data as Quiz[];
}

export async function getQuiz(quizId: number): Promise<Quiz> {
  const res = await api.get(`/api/quizzes/${quizId}`);
  return res.data as Quiz;
}

export async function updateQuiz(quizId: number, quizData: any) {
  const res = await api.put(`/api/quizzes/${quizId}`, quizData);
  return res.data;
}

export async function startQuizAttempt(quizId: number, data: { quiz_id: number, student_id: number }) {
  const res = await api.post(`/api/quizzes/${quizId}/attempts`, data);
  return res.data;
}

export async function submitQuizResponses(quizId: number, attemptId: number, responses: any) {
  const res = await api.post(`/api/quizzes/${quizId}/attempts/${attemptId}/responses`, responses);
  return res.data;
}

export async function getQuizResults(quizId: number) {
  const res = await api.get(`/api/quizzes/${quizId}/results`);
  return res.data;
}

export async function getAttemptResults(attemptId: number) {
  const res = await api.get(`/api/quizzes/attempts/${attemptId}/results`);
  return res.data;
}

export async function gradeQuizResponse(responseId: number, isCorrect: boolean) {
  const res = await api.patch(`/api/quizzes/responses/${responseId}/grade`, { is_correct: isCorrect });
  return res.data;
}

export async function listQuizAttempts(studentId?: number, quizId?: number) {
  const params: any = {};
  if (studentId) params.student_id = studentId;
  if (quizId) params.quiz_id = quizId;
  const res = await api.get('/api/quizzes/attempts', { params });
  return res.data;
}

export async function downloadExamReportPDF(attemptId: number, filename?: string): Promise<void> {
  try {
    const response = await api.get(`/api/quizzes/attempts/${attemptId}/report-pdf`, {
      responseType: 'blob',
    });
    
    // Create a blob URL for the PDF
    const blob = new Blob([response.data as BlobPart], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Create a temporary link element and trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = filename || `exam-report-${attemptId}.pdf`;
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading exam report PDF:', error);
    throw error;
  }
} 